import { Component } from '@angular/core';

@Component({
  selector: 'app-selection-dialog.component',
  standalone: false,
  templateUrl: './selection-dialog.component.html',
  styleUrls: ['./selection-dialog.component.css']
})
export class SelectionDialogComponent {
  value?: number;
}
